import React, { useEffect, useState } from 'react';
import { useAudio } from '../../contexts/AudioContext';
import { IoCloseOutline } from 'react-icons/io5';
import { FeedbackMessage } from '../FeedbackMessage/FeedbackMessage'; // Import the new component
import { MdFormatListBulletedAdd } from 'react-icons/md';
import './AddToQueueButton.css';

export function AddToQueueButton({ clip, size = "40px", color = "white", isInAutoqueue = false }) {
    const { addToQueue, removeFromQueueById, removeFromAutoqueueById, queue } = useAudio();
    const [isAdded, setAdded] = useState();
    const [feedbackMessage, setFeedbackMessage] = useState('');

    useEffect(() => {
        let newIsAdded = queue.some(c => clip.id === c.id);
        setAdded(newIsAdded);
    }, [queue]);

    const handleAdd = (event) => {
        event.stopPropagation(); // Prevent event from propagating to parent
        if (!isAdded) {
            setFeedbackMessage('Added to queue!');
            addToQueue(clip);
            setAdded(true);
        }
    };

    const handleRemove = (event) => {
        event.stopPropagation(); // Prevent event from propagating to parent
        if (isAdded) {
            removeFromQueueById(clip.id);
            setAdded(false);
        }
    };

    const handleRemoveFromAutoqueue = (event) => {
        event.stopPropagation(); // Prevent event from propagating to parent
        removeFromAutoqueueById(clip.id);
        setAdded(false);
    }

    return (
        <div className='addToQueueButton'>

            {isInAutoqueue ?
                <IoCloseOutline size={size} color={color} onClick={handleRemoveFromAutoqueue} style={{ cursor: 'pointer' }} />
                :
                (isAdded ?
                    <IoCloseOutline size={size} color={color} onClick={handleRemove} style={{ cursor: 'pointer' }} />
                    : <MdFormatListBulletedAdd size={size} color={color} onClick={handleAdd} style={{ cursor: 'pointer' }} />
                )
            }

            <FeedbackMessage message={feedbackMessage} onClear={() => setFeedbackMessage('')} />
        </ div>
    );
}
